// Copyright (c) 2026 PGNS LLC

import { Skeleton } from '@pgns/ui/skeleton';
import { DataUnavailable } from '@/components/data-unavailable';
import { IncidentTimeline } from '@/components/incident-timeline';
import { useStatusData } from '@/hooks/use-status-data';

/** Full incident history — the API caps this at the 50 most recent incidents. */
export function IncidentsPage() {
  const { incidents, loading, error } = useStatusData();
  if (loading) return <Skeleton className="h-40 w-full" />;
  return (
    <div className="space-y-6">
      <h1 className="text-2xl font-semibold">Incident history</h1>
      {error !== null && <DataUnavailable stale={incidents !== null} />}
      <IncidentTimeline
        incidents={incidents?.incidents ?? []}
        compact
        emptyMessage="No incidents have been recorded."
      />
    </div>
  );
}
